<template>
  <v-card>
    <v-card-title class="d-flex align-start">
      <h3 class="black2-color dialog-title ma-0 mr-auto text-bold break-word">
        Rent protection & Legal expenses eligibility check
      </h3>
    </v-card-title>
    <v-card-text class="mb-2">
      <LandlordsEligibilityCoverContent />
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions
      class="flex-column align-center fixed-section__wrapper bottom-0"
    >
      <v-btn
        depressed
        x-large
        rounded
        color="psorange"
        class="font-20 font-weight-bold mb-4"
        :class="$vuetify.breakpoint.lgAndUp ? 'mx-2' : ''"
        :style="{
          height: $vuetify.breakpoint.lgAndUp ? '68px !important' : '60px',
        }"
        @click="handleConfirmEligibility"
        aria-label="Confirm Eligibility"
        >Confirm Eligibility</v-btn
      >
      <div>
        <a @click="handleEligibilityNotMet" class="font-18"
          ><u>Don't meet eligibility criteria?</u></a
        >
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import LandlordsEligibilityCoverContent from "@/components/D2CSharedComponents/LandlordsEligibilityCoverContent.vue";

export default {
  name: "LandlordsEligibilityCover",
  components: {
    LandlordsEligibilityCoverContent,
  },
  methods: {
    handleConfirmEligibility() {
      this.$emit("confirm-eligibility");
    },
    handleEligibilityNotMet() {
      this.$emit("eligibility-not-meet");
    },
    cancel() {
      this.$emit("cancel-eligibility");
    },
  },
};
</script>

<style lang="scss" scoped>
.v-sheet {
  box-shadow: none !important;
}
.v-card {
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 151px;
  padding-top: 121px;
  .v-card__title {
    padding: 0px 40px 24px 40px;
    .dialog-title {
      font-size: 26px !important;
      max-width: 90%;
    }
  }

  .v-card__text {
    color: $black-2 !important;
    padding: 16px 40px !important;
    overflow-y: auto;
    flex-grow: 1;
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgb(255 255 255 / 0%);
      border-radius: 10px;
      background-color: #ebebeb;
    }

    &::-webkit-scrollbar {
      width: 10px;
      background-color: #ebebeb;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgb(255 250 250 / 30%);
      background-color: #aaa;
    }
  }

  .v-card__actions {
    padding: 24px 26px 24px 19px;
    .v-btn {
      &.v-size--x-large {
        color: $black-2;
        height: 60px !important;
        width: 100%;
      }
    }

    a {
      color: $black-2;
    }
  }
}

@media screen and (min-width: $grid-breakpoints-lg) {
  .v-card {
    padding-top: 94px;
    .v-card__title {
      .dialog-title {
        font-size: 26px !important;
        max-width: 573px;
      }
    }
    .v-card__text {
      color: $black-2 !important;
      padding: 16px 37px;
    }
    .v-card__actions {
      padding: 24px 44px 24px 44px;
    }
  }
}
</style>
